export default __webpack_public_path__ + "static/media/Dogmatist's Tasset.d5d85a20.jpg";